import * as queries from '@supabase/queries';
import { useEffect, useState } from "react";
import { supabase } from "../../supabase/supabaseClient";
import { useNavigate, useSearchParams } from "react-router-dom";
import type { Session } from "@supabase/supabase-js";


export function useGetUserSession() {
    const [session, setSession] = useState<Session | null>(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const handleInvite = async () => {
            const token = searchParams.get('token');
            const type = searchParams.get('type');
            console.log(type)
            if (type === 'invite' && token) {
                try {
                    // Verify the token with Supabase
                    const { data, error } = await supabase.auth.verifyOtp({
                        token_hash: token,
                        type: 'invite'
                    });
                    console.log(data)

                    if (error) throw error;

                    // User is now authenticated, redirect to complete profile
                    navigate('/account-setup');
                } catch (err) {
                    console.error(err)
                }
            }
        };

        handleInvite();
    }, [searchParams, navigate]);
    useEffect(() => {
        setIsLoading(true)
        queries.getUserSession().then(({ data: { session } }) => {
            setSession(session)
        })
        const { data: subscription } = supabase.auth.onAuthStateChange((event, session) => {
            setSession(session)
            if (event === "PASSWORD_RECOVERY") {
                navigate("/update-password");
            }
            setIsLoading(false)
        })
        return () => subscription?.subscription?.unsubscribe();
    }, [])
    return { data: session, isLoading };
}
